module.exports = __webpack_public_path__ + "static/media/mx.9cbc6a4d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mx.svg
// module id = 2167
// module chunks = 0